import Visibility from "@mui/icons-material/Visibility";
import { IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import ExportButton from "../../../commons/export/ExportButton";
import { tableStyles } from "../../../commons/table/tableConfig";

const ResumenGestionTable = ({ data, loading, handleViewDetails, display }) => {
  const columns = [
    {
      header: "Período",
      accessorKey: "periodo",
      align: "center",
      enableColumnActions: false,
    },
    {
      header: "Lote",
      accessorKey: "idLote",
      align: "center",
      enableColumnActions: false,
    },
    {
      header: "Expuestos",
      accessorKey: "expuestos",
      align: "center",
      enableColumnActions: false,
    },
    {
      header: "Examinados",
      accessorKey: "examinados",
      align: "center",
      enableColumnActions: false,
    },
    {
      header: "Inculpables",
      accessorKey: "inculpables",
      align: "center",
      enableColumnActions: false,
    },
    {
      header: "Normales",
      accessorKey: "normales",
      align: "center",
      enableColumnActions: false,
    },
    {
      header: "Patológicos",
      accessorKey: "patologicos",
      align: "center",
      enableColumnActions: false,
    },
    {
      header: "Ausentes",
      accessorKey: "ausentes",
      align: "center",
      enableColumnActions: false,
    },
    {
      header: "En proceso",
      accessorKey: "enProceso",
      align: "center",
      enableColumnActions: false,
    },
  ];

  return (
    <MaterialReactTable
      enableRowActions
      renderRowActions={
        ({ row }) => (
          <Tooltip title="Ver trabajadores">
            <IconButton size="medium" onClick={() => {
              handleViewDetails(row.original.idLote)

            }}>
              <Visibility />

            </IconButton>
          </Tooltip>
        )
      }
      positionActionsColumn="last"
      columns={columns}
      data={data}
      layoutMode="grid"
      state={{ isLoading: loading }}
      localization={MRT_Localization_ES}
      style={{ ...tableStyles.container, }}
      initialState={{ showColumnFilters: true }}
      title=""
      renderToolbarInternalActions={(props) => (
        <ExportButton
          data={data}
          columns={columns}
          disabled={data.length === 0}
          title="Resumen de Gestión"
        />

      )
      }
    />
  );
};

export default ResumenGestionTable;
